// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Jjz4","top":"styles_top__2B8od"};